import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import moment from 'moment';

import { HemsProperties } from '@vi-iot/client';

import { Observable } from 'rxjs';

import { FilterType } from './../../+installations/installation/energy-historical-data-modal/energy-filters-header/energy-filters.data';
import { EnergyHistoricalDataActions } from './energy-historical-data.actions';
import { HemsFlowType } from './energy-historical-data.helpers';
import { LegendFeature } from './energy-historical-data.model';
import { EnergyHistoricalDataSelectors } from './energy-historical-data.selectors';
import Moment = moment.Moment;

@Injectable({
  providedIn: 'root',
})
export class EnergyHistoricalDataStore {
  state$ = this.store.select(EnergyHistoricalDataSelectors.getState());
  chartData$ = this.store.select(EnergyHistoricalDataSelectors.selectChartData());
  filterType$ = this.store.select(EnergyHistoricalDataSelectors.selectFilterType());
  filterDate$ = this.store.select(EnergyHistoricalDataSelectors.selectFilterDate());
  selectedFeatures$ = this.store.select(EnergyHistoricalDataSelectors.selectSelectedFeatures());
  savedSelectedFeatures$ = this.store.select(
    EnergyHistoricalDataSelectors.selectSavedSelectedFeatures()
  );
  legendFeatures$ = this.store.select(EnergyHistoricalDataSelectors.selectLegendFeatures());
  loading$ = this.store.select(EnergyHistoricalDataSelectors.getLoading());
  error$ = this.store.select(EnergyHistoricalDataSelectors.selectError());
  hemsAnalysisSelectedTab$: Observable<HemsFlowType> = this.store.select(
    EnergyHistoricalDataSelectors.selectHemsAnalysisSelectedTab()
  );
  selectedSessionStorageFeatures$ = this.store.select(
    EnergyHistoricalDataSelectors.selectSavedSelectedFeatures()
  );

  constructor(private store: Store) {}

  addLegendFeature(feature: LegendFeature): void {
    this.store.dispatch(EnergyHistoricalDataActions.addLegendFeature({ feature }));
  }

  clearLegendFeatures(): void {
    this.store.dispatch(EnergyHistoricalDataActions.clearLegendFeatures());
  }

  loadChartData(): void {
    this.store.dispatch(EnergyHistoricalDataActions.loadChartData());
  }

  setFilterType(filterType: FilterType, date: Moment): void {
    this.store.dispatch(EnergyHistoricalDataActions.updateFilters({ filterType, date }));
  }

  updateSelectedFeatures(selectedFeatures: HemsProperties[]): void {
    this.store.dispatch(EnergyHistoricalDataActions.updateSelectedFeatures({ selectedFeatures }));
  }

  resetSelectedFeatures(): void {
    this.store.dispatch(EnergyHistoricalDataActions.resetSelectedFeatures());
  }

  resetStore(): void {
    this.store.dispatch(EnergyHistoricalDataActions.resetStore());
  }

  getLegacyHPChartData(
    gatewaySerial: string,
    fetchOnlyDayValues: boolean,
    feature: HemsProperties
  ): void {
    this.store.dispatch(
      EnergyHistoricalDataActions.loadLegacyHPChartData({
        gatewaySerial,
        fetchOnlyDayValues,
        feature,
      })
    );
  }

  setHemsAnalysisTab(hemsAnalysisTab: HemsFlowType): void {
    this.store.dispatch(EnergyHistoricalDataActions.setHemsAnalysisTab({ hemsAnalysisTab }));
  }

  saveSelectedFeaturesToStorage(
    installationId: string,
    isThermalFlow: boolean,
    savedSelectedFeatures: HemsProperties[]
  ): void {
    this.store.dispatch(
      EnergyHistoricalDataActions.saveSelectedFeatureToStorage({
        savedSelectedFeatures,
        installationId,
        isThermalFlow,
      })
    );
  }

  loadSelectedFeatureFromStorage(): void {
    this.store.dispatch(EnergyHistoricalDataActions.loadSelectedFeatureFromStorage.attempt());
  }

  getSelectedFeatures(
    installationId: string
  ): Observable<{
    electricitySelectedFeatures: HemsProperties[];
    heatingSelectedFeatures: HemsProperties[];
  }> {
    return this.store.select(
      EnergyHistoricalDataSelectors.selectSavedSelectedFeaturesForInstallationId(installationId)
    );
  }
}
